import { useMemo } from 'react';
import useSWR from 'swr';
import type { ComplianceReviewer } from '@shared/api/contracts/compliance';
import { useApiServices } from '@shared/lib/use-api-services';
import { swrKeys } from '@shared/api/swr/keys';

/** Активные ADMIN для назначения ответственного (бек: role ADMIN, не banned). */
export function useReconciliationAssignees(enabled: boolean) {
  const services = useApiServices();
  const { data, error, isLoading, mutate } = useSWR(enabled ? swrKeys.compliance.reviewers() : null, () =>
    services.compliance.listReviewers(),
  );

  const assignees = useMemo(
    () =>
      (data?.data ?? [])
        .filter((row): row is ComplianceReviewer => !row.bannedAt)
        .sort((a, b) => a.email.localeCompare(b.email, undefined, { sensitivity: 'base' })),
    [data?.data],
  );

  return { assignees, isLoading, error, refresh: mutate };
}

export const formatReconciliationAssigneeLabel = (
  assigneeId: number | null | undefined,
  assignees: ComplianceReviewer[],
): string => {
  if (assigneeId == null) return '';
  const match = assignees.find((item) => item.id === assigneeId);
  return match ? match.email : `#${assigneeId}`;
};
